export default "__VITE_ASSET__26Hvc_s1__"